<script setup lang="ts">
import ViewOrders from '@/components/orders/view-orders.vue';
</script>

<template>
  <div>
    <ViewOrders />
  </div>
</template>
